/* AV1 PDP — variant selection, add to cart (wired into Pipeline's cart drawer),
   sticky mobile ATC, gallery counter. */
(function () {
  var root = document.querySelector("[data-av1-product]");
  if (!root) return;

  var variantsEl = root.querySelector("[data-variants-json]");
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var optionCount = variants.length && variants[0].options ? variants[0].options.length : 0;

  var form = root.querySelector("[data-product-form]");
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var priceEls = root.querySelectorAll("[data-price]");
  var atcBtn = root.querySelector("[data-atc]");
  var atcLabel = root.querySelector("[data-atc-label]");
  var errorEl = root.querySelector("[data-atc-error]");
  var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* --- selected value per option index --- */
  var selected = [];
  root.querySelectorAll("[data-option-index]").forEach(function (row) {
    var idx = parseInt(row.getAttribute("data-option-index"), 10);
    var current = row.querySelector('[aria-selected="true"]');
    if (current) selected[idx] = current.getAttribute("data-value");
  });

  function currentVariant() {
    return variants.find(function (v) {
      for (var i = 0; i < optionCount; i++) {
        if (selected[i] != null && v.options[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function refreshAvailability() {
    root.querySelectorAll("[data-option-index]").forEach(function (row) {
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      row.querySelectorAll("[data-value]").forEach(function (el) {
        var value = el.getAttribute("data-value");
        var anyAvailable = variants.some(function (v) {
          if (v.options[idx] !== value) return false;
          for (var i = 0; i < optionCount; i++) {
            if (i !== idx && selected[i] != null && v.options[i] !== selected[i]) return false;
          }
          return v.available;
        });
        el.setAttribute("data-available", anyAvailable ? "true" : "false");
        if (el.tagName === "BUTTON") el.disabled = !anyAvailable && el.classList.contains("pill");
      });
    });
  }

  function refresh() {
    var v = currentVariant();
    if (!v) return;
    if (idInput) idInput.value = v.id;
    priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? atcLabel.getAttribute("data-add-text") : atcLabel.getAttribute("data-soldout-text");
    }
    refreshAvailability();
  }

  /* --- clicks on tiers and pills (both carry data-option-index/data-value) --- */
  root.querySelectorAll("[data-option-index]").forEach(function (row) {
    var idx = parseInt(row.getAttribute("data-option-index"), 10);
    var pickedLabel = row.getAttribute("data-picked") ? document.getElementById(row.getAttribute("data-picked")) : null;
    row.querySelectorAll("[data-value]").forEach(function (el) {
      el.addEventListener("click", function () {
        if (el.getAttribute("data-available") === "false" && el.classList.contains("pill")) return;
        row.querySelectorAll("[data-value]").forEach(function (o) { o.setAttribute("aria-selected", "false"); });
        el.setAttribute("aria-selected", "true");
        selected[idx] = el.getAttribute("data-value");
        if (pickedLabel) pickedLabel.textContent = el.getAttribute("data-value");
        refresh();
      });
    });
  });

  /* --- add to cart: same flow Pipeline uses (add.js -> cart.js -> events -> drawer) --- */
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add("is-on");
    setTimeout(function () { errorEl.classList.remove("is-on"); }, 5000);
  }

  function addToCart() {
    if (!form || !idInput || !idInput.value) return;
    fetch((window.theme && window.theme.routes && window.theme.routes.cart ? window.theme.routes.cart : "/cart") + "/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "Could not add to cart"); });
        return r.json();
      })
      .then(function () {
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (drawer && toggle) {
          toggle.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
        } else {
          /* No cart drawer on this theme (disabled in group-overlay) — go to the cart page */
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || "/cart";
        }
      })
      .catch(function (e) {
        showError(e.message || "Could not add to cart — please try again.");
      });
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      addToCart();
    });
  }
  var stickyBtn = root.querySelector("[data-sticky-atc-btn]");
  if (stickyBtn) stickyBtn.addEventListener("click", addToCart);

  /* --- sticky mobile ATC appears once the buy button scrolls off --- */
  var sticky = root.querySelector("[data-sticky-atc]");
  if (atcBtn && sticky && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle("visible", !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(atcBtn);
  }

  /* --- mobile gallery counter --- */
  var gallery = root.querySelector("[data-gallery]");
  var count = root.querySelector("[data-gallery-count]");
  if (gallery && count) {
    var total = gallery.querySelectorAll("figure").length;
    gallery.addEventListener("scroll", function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      count.textContent = Math.min(Math.max(i, 1), total) + " / " + total;
    }, { passive: true });
  }

  refresh();
})();

/* --- founder video: play on click (section lives outside the product root) --- */
(function () {
  document.querySelectorAll("[data-founder-video]").forEach(function (wrap) {
    var video = wrap.querySelector("video");
    if (!video) return;
    wrap.addEventListener("click", function () {
      if (wrap.classList.contains("is-playing")) return;
      wrap.classList.add("is-playing");
      video.setAttribute("controls", "");
      video.play();
    });
    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        wrap.click();
      }
    });
  });
})();
